export default "__VITE_ASSET__DUtLXe92__"